module.exports = __webpack_public_path__ + "img/injectionsteps_step4.71be062d.png";